import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { FsPolicyOptionResponse } from '../models';

@Injectable({
  providedIn: 'root',
})
export class FsPoliciesService {
  constructor(private readonly _httpClient: HttpClient) {}

  public options(): Observable<FsPolicyOptionResponse> {
    return this._httpClient.get<FsPolicyOptionResponse>('/api/auth/policy/valid-options/');
  }
}
